const SOCKET_URL =
  process.env.NODE_ENV === "production" ? "wss://live.squares-app.com" : "ws://localhost:3001";

const INITIAL_BACKOFF = 1000;
const MAX_BACKOFF = 20 * 1000;
const JITTER_FACTOR = 0.2;
const MAX_RETRIES = 10;

function jitter(val) {
  return Math.round((Math.random() * 2 * JITTER_FACTOR - JITTER_FACTOR + 1) * val);
}

export const Status = {
  CONNECT: "CONNECT",
  OPEN: "OPEN",
  RETRY: "RETRY",
  FAILED: "FAILED",
};

export function subscribe(path, gameCB, statusCB) {
  let socket = null;
  let retries = MAX_RETRIES;
  let backoff = INITIAL_BACKOFF;
  let subscribed = true;

  statusCB = statusCB || (() => {});

  const connect = () => {
    const ws = new WebSocket(`${SOCKET_URL}/ws/${path}`);
    statusCB(Status.CONNECT);
    ws.onmessage = event => {
      console.log(`EVENT: ${event.type} ${event.data}`);
      try {
        const gameState = JSON.parse(event.data);
        console.log(gameState);
        if (subscribed) {
          gameCB(gameState);
        }
      } catch (e) {
        console.error("Error parsing message", e);
      }
    };
    ws.onopen = () => {
      console.log("socket open");
      socket = ws;
      retries = MAX_RETRIES;
      backoff = INITIAL_BACKOFF;
      statusCB(Status.OPEN);
    };
    ws.onclose = () => {
      console.log("socket closed");
      socket = null;

      if (retries > 0 && subscribed) {
        const waitTime = jitter(backoff);
        console.log(`Waiting ${waitTime} to reconnect (${retries - 1} remaining)`);
        setTimeout(connect, waitTime);
        backoff = Math.min(backoff * 2, MAX_BACKOFF);
        retries--;
        statusCB(Status.RETRY);
      } else if (retries === 0) {
        console.log("Too many failures");
        statusCB(Status.FAILED);
      }
    };
  };
  connect();

  return {
    send: message => {
      if (!socket) {
        return;
      }
      socket.send(message);
    },

    unsubscribe: () => {
      console.log("unsubscribe");
      subscribed = false;
      socket && socket.close();
    },
  };
}



// WEBPACK FOOTER //
// ./src/Scores.js